var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.containerClass},[_c('div',{class:_vm.className},[(_vm.title)?_c('div',{staticClass:"b-portlet-header"},[_c('div',{staticClass:"subtitle is-4 has-text-primary"},[_vm._v(_vm._s(_vm.title))])]):_vm._e(),_c('div',{staticClass:"b-portlet-body"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }